import { stringField, optionField } from 'common/utils/form/fieldTypes';

export default {
  name: stringField({ required: true }),
  iata_designator: stringField(),
  icao_code: stringField(),
  ['3_digit_code']: stringField({ required: true }),
  country: optionField()
};
